import { TeamOutlined, FileTextOutlined, CheckSquareOutlined, BellOutlined } from '@ant-design/icons';

const accounts = {
  id: 'group-ground-ops',
  title: 'Ground Operations',
  type: 'group',
  children: [
    {
      id: 'agent-network',
      title: 'Agent Network',
      type: 'item',
      url: '/ground-operations/agent-network',
      icon: TeamOutlined
    },
    {
      id: 'field-reports',
      title: 'Agent Reports',
      type: 'item',
      url: '/agent-activity',
      icon: FileTextOutlined
    },
    {
      id: 'agent-task',
      title: 'Agent Task',
      type: 'item',
      url: '/ground-operations/agent-task',
      icon: CheckSquareOutlined
    },
    {
      id: 'agent-notifications',
      title: 'Agent Notification',
      type: 'item',
      url: '/ground-operations/agent-notifications',
      icon: BellOutlined
    }
  ]
};

export default accounts;
